export default "__VITE_ASSET__Dq5Mg0X2__"